import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface ProgramTiles {
  sectionHeader?: string | null;
  programTiles?: ProgramTile[] | null;
}

export interface ProgramTile {
  imageUrl?: string | null;
  heading?: string | null;
  subHeading?: string | null;
  statusText?: string | null;
  showButton?: boolean | null;
  isExternal?: boolean | null;
  routingUrl?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  http = inject(HttpClient);

  async getProgramTiles(): Promise<ProgramTiles> {
    try {
      return firstValueFrom(this.http.get<ProgramTiles>('Dashboard/program-tiles'));
    } catch (error) {
      throw new Error('Failed to load program tiles');
    }
  }
}
